module.exports = __webpack_public_path__ + "img/label.a5b3f008.svg";